import React from "react";
import { withRouter } from "react-router-dom";
import { Wrapper } from "@networkraildigitalfactory/components";
import PageTitle from "../PageTitle/PageTitle";
import styles from "./MyNotifications.module.css";
import NotificationFeed from "../NotificationFeed/NotificationFeed";

const MyNotifications = () => {
  const paragraph = [
    "View your iPerform notifications below so that you can keep up-to-date with any changes.",
  ];

  return (
    <Wrapper maxWidth={1375} align="center">
      <PageTitle titleHeader="Notifications" titleParagraph={paragraph} hideButton />
      <div className={styles.listBorder}>
        <NotificationFeed isModal={false} />
      </div>
    </Wrapper>
  );
};

export default withRouter(MyNotifications);
